module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.9.1-269.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.9.1.md
// module id = 714
// module chunks = 226